import * as commonScripts from '../common'

const cmpFundHero = {
  component: null,
  adjustBanner: false,
  overview: null,
  offset: null,
  threshold: 0,
  scrollTimer: 0,

  init: function (element) {
    const _ = this
    const loc = window.location
    const dropdown = element.querySelector('select')

    if (dropdown) {
      const key = dropdown.getAttribute('name')
      dropdown.addEventListener('change', (e) => {
        const url = loc.origin + loc.pathname + '?' + key + '=' + encodeURIComponent(dropdown.value)
        window.location.assign(url)
      })
    }

    if (_.adjustBanner) {
      _.overview = element.querySelector('.cmp-fund-hero__overview')
      _.offset = commonScripts.util.getOffsetAbsolute(_.overview)
      _.threshold = _.offset.top - 150
      _.adjustBannerPosition()

      window.addEventListener('scroll', (e) => {
        clearTimeout(_.scrollTimer)
        _.scrollTimer = setTimeout(() => {
          _.adjustBannerPosition()
        }, 10)
      })
    }
  },

  adjustBannerPosition: function () {
    const _ = this
    if (window.scrollY > _.threshold) {
      document.body.classList.add('fixed-banner')
      document.body.style.paddingTop = _.offset.top + 50 + 'px'
    } else {
      document.body.classList.remove('fixed-banner')
      document.body.style.paddingTop = 0
    }
  }
}

export default cmpFundHero
